export const backgroundGradient = `
  linear-gradient(270deg, rgba(242, 245, 247, 0) 86.48%, #f2f5f7 100%),
  linear-gradient(90deg, rgba(242, 245, 247, 0) 87.89%, #f2f5f7 100%),
  radial-gradient(50% 50% at 100% 0%, rgba(255, 231, 221, 0.55) 0%, rgba(242, 245, 247, 0.55) 100%),
  radial-gradient(50% 50% at 0% 0%, rgba(255, 231, 172, 0.55) 0%, rgba(242, 245, 247, 0.55) 100%),
  radial-gradient(34.88% 34.88% at 50% 0%, #ffaa8e 0%, #f2f5f7 100%),
  var(--Main-Colors-Background-Surface, #f2f5f7)
`;
